import { GzExchangeScanTaskWebComponent } from './component/GzExchangeScanTaskWebComponent';

export { GzExchangeScanTaskWebComponent };
